package ru.education.building.theme

import com.russhwolf.settings.Settings

enum class ThemeMode {
    LIGHT, DARK, AUTO
}

class ThemePreferences(private val settings: Settings = Settings()) {
    companion object {
        private const val THEME_MODE_KEY = "theme_mode"
    }

    var themeMode: ThemeMode
        get() {
            val modeName = settings.getStringOrNull(THEME_MODE_KEY) ?: ThemeMode.AUTO.name
            return runCatching { ThemeMode.valueOf(modeName) }.getOrDefault(ThemeMode.AUTO)
        }
        set(value) {
            settings.putString(THEME_MODE_KEY, value.name)
        }
}

